import { render, staticRenderFns } from "./NavbarNotificationBadge.vue?vue&type=template&id=db2ecae8&scoped=true"
import script from "./NavbarNotificationBadge.vue?vue&type=script&lang=js"
export * from "./NavbarNotificationBadge.vue?vue&type=script&lang=js"
import style0 from "./NavbarNotificationBadge.vue?vue&type=style&index=0&id=db2ecae8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2ecae8",
  null
  
)

export default component.exports